import { Address } from './address.model';
import { UUID } from "angular2-uuid";
import { DocumentModel } from "./document.model";

export interface PoItem {
  poId: string;
  quantity: number;
}

export class InstallationLocation {
  id: string;
  poItems: PoItem[];
  address: Address;
  date: Date;
  // Delivery images
  deliveryImages: DocumentModel[];
  // Images before work
  beforeImages: DocumentModel[];
  // Images after work
  afterImages: DocumentModel[];

  constructor(installationLocation?: Partial<InstallationLocation> & {
    poId?: string; quantity?: number;
  }) {
    this.id = installationLocation?.id ?? UUID.UUID();
    if (installationLocation?.poItems) {
      this.poItems = [...installationLocation.poItems];
    } else {
      // Backward compat: migrate legacy single poId + quantity to poItems array
      const poId = installationLocation?.poId;
      const quantity = installationLocation?.quantity ?? 0;
      this.poItems = poId ? [{ poId, quantity }] : [];
    }
    this.address = installationLocation?.address ? new Address(installationLocation.address) : new Address();
    const rawDate = installationLocation?.date;
    this.date = rawDate instanceof Date ? new Date(rawDate.getTime()) : (rawDate ? new Date(rawDate as any) : null);
    this.deliveryImages = installationLocation?.deliveryImages ?? [];
    this.beforeImages = installationLocation?.beforeImages ?? [];
    this.afterImages = installationLocation?.afterImages ?? [];
  }

  /**
   * Whether a location has at least one photo of each required type (colis / avant / finis).
   * @param loc Installation location (or compatible shape)
   * @returns True when delivery, before and after photos are present
   */
  static arePhotosReady(loc: Pick<InstallationLocation, 'deliveryImages' | 'beforeImages' | 'afterImages'>): boolean {
    return (loc.deliveryImages?.length ?? 0) > 0 &&
      (loc.beforeImages?.length ?? 0) > 0 &&
      (loc.afterImages?.length ?? 0) > 0;
  }
}
